import { render, staticRenderFns } from "./LgsRequirement.vue?vue&type=template&id=43bf61bc&"
import script from "./LgsRequirement.vue?vue&type=script&lang=js&"
export * from "./LgsRequirement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports